<template>
    <div id="user-create-view" class="view form-view">
        <h2>Create user</h2>

        <user-form :form="form" :has-aad-license="checkAzureADLicence()" :handler="createUser"></user-form>
    </div>
</template>

<script>
import UserForm from './components/UserForm'
import UserApi from '@/api/UserApi'
import toast from '../../plugins/izitoast'
import router from '../../router/routes'
import { mapGetters } from 'vuex'
import moment from 'moment'

const userApi = new UserApi()

export default {
    name: 'CreateUser',
    components: {
        UserForm
    },
    data () {
        return {
            form: {
                userName: '',
                firstName: '',
                lastName: '',
                email: '',
                phoneNumber: '',
                password: '',
                azureAdId: '',
                permissions: null,
                organizationId: null,
                expiresIn: null,
                roles: null,
                accessForAllSubOrgs: false
            }
        }
    },
    computed: {
        ...mapGetters({
            getOrganizationLicenses: 'activeOrganizationData/getOrganizationLicenses',
            getActiveOrganization: 'authModule/getActiveOrganization'
        })
    },
    methods: {
        async createUser (form) {
            const {
                userName,
                firstName,
                lastName,
                phoneNumber,
                email,
                password,
                permissions,
                roles,
                expiresIn,
                accessForAllSubOrgs,
                azureAdId
            } = form

            const response = await userApi.createUser({
                userName,
                firstName,
                lastName,
                phoneNumber,
                email,
                password,
                permissions,
                roles,
                expiresIn: expiresIn ? moment(expiresIn).format('YYYY-MM-DDTHH:mm:ss').toString() + 'Z' : null,
                organizationId: this.getActiveOrganization,
                accessForAllSubOrgs,
                ...(this.checkAzureADLicence() && azureAdId ? { activated: true } : {}),
                ...(this.checkAzureADLicence() && azureAdId ? { azureAdId } : {})
            })

            if (!response.isSuccess) {
                return
            }

            toast.success('User successfully created.')
            if (this.hasAllRoles(['UserUpdate'])) {
                router.push('/settings/users/edit/' + response.payload)
            }
        }
    }
}
</script>

<style scoped>

</style>
